<script setup lang="ts">
type Props = {
  iconUrl?: string | null;
  highlight: string;
};

const props = defineProps<Props>();
const i18n = useI18n();

const label = computed(() => {
  return translateWithFallback(
    i18n,
    `product.highlights.${props.highlight}`,
    props.highlight,
  );
});
</script>

<template>
  <div
    class="uppercase truncate font-bold py-1 px-[.375rem] text-xs rounded-sm border border-background-2 bg-platform-bg-1 inline-flex items-center gap-1"
  >
    <NuxtImg
      v-if="iconUrl"
      :src="iconUrl"
      :alt="`${label} icon`"
      width="12"
      height="12"
    />
    <span>
      {{ label }}
    </span>
  </div>
</template>
